import React, { useState } from "react";
import { DatePicker, TimePicker, Space } from "antd";

const TIME_FORMAT = "HH:mm";
const DEFAULT_TIME = {
  startOfDay: (date) => date.startOf("day"),
  endOfDay: (date) => date.endOf("day"),
};

const applyTime = (date, time) =>
  date.hour(time.hour()).minute(time.minute()).second(0).millisecond(0);

const DateTimePicker = ({
  id,
  value = null,
  onChange,
  defaultTime = "startOfDay",
  size,
  className,
  style,
}) => {
  const withoutTime = DEFAULT_TIME[defaultTime];
  const [detachedTime, setDetachedTime] = useState(null);

  const hasTime = value && !value.isSame(withoutTime(value), "minute");
  const time = value ? (hasTime ? value : null) : detachedTime;

  const handleDateChange = (date) => {
    if (!date) {
      setDetachedTime(time);
      onChange?.(null);
      return;
    }

    onChange?.(time ? applyTime(date, time) : withoutTime(date));
  };

  const handleTimeChange = (nextTime) => {
    if (!value) {
      setDetachedTime(nextTime);
      return;
    }

    onChange?.(nextTime ? applyTime(value, nextTime) : withoutTime(value));
  };

  return (
    <Space.Compact className={className} style={{ width: "100%", ...style }}>
      <DatePicker
        id={id}
        value={value}
        onChange={handleDateChange}
        size={size}
        style={{ width: "50%" }}
      />
      <TimePicker
        value={time}
        onChange={handleTimeChange}
        format={TIME_FORMAT}
        placeholder="Time"
        size={size}
        style={{ width: "50%" }}
      />
    </Space.Compact>
  );
};

export default DateTimePicker;
